import cookie from "services/CookieStorage"
import LogRocketLib from "logrocket"


// donot track these emails
const testEmails = [
  "biju@radiusagent.com",
]
const emailsToTrack = [
  "Kimberly.grovers@radiusagent.com",
  "preticia@radiusagent.com",
]
class LogRocket {
  initialize = (trackOnlyAuthorized = true) => {
    try {
      const user = cookie.load("user")
      const { origin } = window.location
      if (process?.env?.REACT_APP_NODE_ENV !== "production") {
        return
      }
      // disable base route for soul
      if (!origin.includes("soul.")) {
        return
      }
      if (testEmails.includes(user.email)) {
        return
      }
      if (user && user.email && user.agent_id && emailsToTrack.includes(user.email)) {
        LogRocketLib.init("3q0c2i/radius-brokerage-platform")
        LogRocketLib.identify(user.agent_id, {
          name: `${user.name}`,
          email: `${user.email}`,
          twilio_client_name: `${user.twilio_client_name}`,
        })
      }
    } catch (err) {
      console.warn("Error initializing Logrocket!")
    }
  }
}
export default new LogRocket()
